import { useEffect, useState } from 'react';
import { distinctUntilChanged, Observable } from 'rxjs';
import {
  CleanTournament,
  TournamentParticipant,
} from '../../../../corelogic/domain/models/tournament.model';
import { store } from '../../../../corelogic/state/store';
import {
  getTournamentDetails,
  getTournamentDetailsLoading,
  getTournamentError,
  getTournamentLastUpdated,
  getTournamentLoading,
  getTournaments,
  getUserCreatedTournamentLoading,
  getUserCreatedTournaments,
  getUserTournamentLoading,
  getUserTournaments,
} from '../../../../corelogic/state/tournament/tournament.selector';
const tournaments$: Observable<CleanTournament[] | null> =
  store.select(getTournaments);
const userTournaments$: Observable<CleanTournament[] | null> =
  store.select(getUserTournaments);
const userCreatedTournaments$: Observable<CleanTournament[] | null> =
  store.select(getUserCreatedTournaments);
const tournamentDetails$: Observable<TournamentParticipant[] | null> =
  store.select(getTournamentDetails);
const isTournamentLoading$: Observable<boolean> =
  store.select(getTournamentLoading);
const isUserTournamentLoading$: Observable<boolean> = store.select(
  getUserTournamentLoading,
);
const isUserCreatedTournamentLoading$: Observable<boolean> = store.select(
  getUserCreatedTournamentLoading,
);
const isTournamentDetailsLoading$: Observable<boolean> = store.select(
  getTournamentDetailsLoading,
);
const error$: Observable<string | null> = store.select(getTournamentError);
const lastUpdated$: Observable<number | null> = store.select(
  getTournamentLastUpdated,
);

export const useTournamentState = () => {
  const [allTournaments, setAllTournaments] = useState<
    CleanTournament[] | null
  >(null);
  const [userTournaments, setUserTournaments] = useState<
    CleanTournament[] | null
  >(null);
  const [userCreatedTournaments, setUserCreatedTournaments] = useState<
    CleanTournament[] | null
  >(null);
  const [tournamentDetails, setTournamentDetails] = useState<
    TournamentParticipant[] | null
  >(null);
  const [isTournamentLoading, setIsTournamentLoading] = useState(false);
  const [isUserTournamentLoading, setIsUserTournamentLoading] = useState(false);
  const [isUserCreatedTournamentLoading, setIsUserCreatedTournamentLoading] =
    useState(false);
  const [isTournamentDetailsLoading, setIsTournamentDetailsLoading] =
    useState(false);
  const [error, setError] = useState<string | null>(null);
  const [lastUpdated, setLastUpdated] = useState<number | null>(null);

  useEffect(() => {
    const subscription = tournaments$
      .pipe(distinctUntilChanged())
      .subscribe(setAllTournaments);
    const userTournamentSubscription = userTournaments$
      .pipe(distinctUntilChanged())
      .subscribe(setUserTournaments);
    const userCreatedTournamentSubscription = userCreatedTournaments$
      .pipe(distinctUntilChanged())
      .subscribe(setUserCreatedTournaments);
    const tournamentDetailsSubscription = tournamentDetails$
      .pipe(distinctUntilChanged())
      .subscribe(setTournamentDetails);
    const tournamentLoadingSubscription = isTournamentLoading$
      .pipe(distinctUntilChanged())
      .subscribe(setIsTournamentLoading);
    const userTournamentLoadingSubscription = isUserTournamentLoading$
      .pipe(distinctUntilChanged())
      .subscribe(setIsUserTournamentLoading);
    const userCreatedTournamentLoadingSubscription =
      isUserCreatedTournamentLoading$
        .pipe(distinctUntilChanged())
        .subscribe(setIsUserCreatedTournamentLoading);
    const tournamentDetailsLoadingSubscription = isTournamentDetailsLoading$
      .pipe(distinctUntilChanged())
      .subscribe(setIsTournamentDetailsLoading);
    const errorSubscription = error$
      .pipe(distinctUntilChanged())
      .subscribe(setError);
    const lastUpdatedSubscription = lastUpdated$
      .pipe(distinctUntilChanged())
      .subscribe(setLastUpdated);
    return () => {
      subscription.unsubscribe();
      userTournamentSubscription.unsubscribe();
      userCreatedTournamentSubscription.unsubscribe();
      tournamentDetailsSubscription.unsubscribe();
      tournamentLoadingSubscription.unsubscribe();
      userTournamentLoadingSubscription.unsubscribe();
      userCreatedTournamentLoadingSubscription.unsubscribe();
      tournamentDetailsLoadingSubscription.unsubscribe();
      errorSubscription.unsubscribe();
      lastUpdatedSubscription.unsubscribe();
    };
  }, []);

  return {
    allTournaments,
    userTournaments,
    userCreatedTournaments,
    tournamentDetails,
    isTournamentLoading,
    isUserTournamentLoading,
    isUserCreatedTournamentLoading,
    isTournamentDetailsLoading,
    error,
    lastUpdated,
  };
};
